export const setFilterReportesProgramasSanitarios = (filters) => {
    return function (dispatch) {
        dispatch(setFiltro(filters));
    }
}

const setFiltro = (filtros) => ({
    type: "SET_FILTROS_REPORTES_PROGRAMAS_SANITARIOS",
    ...filtros
});